import React, { useState, useEffect, useRef } from 'react';


import "antd/dist/antd.css";
import "./App.css";
import { Input, Table } from "antd";

const Home = () => {

    return (
        <div>Home</div>
    )
};

export default Home;